import { GoogleMapsEmbed } from '@next/third-parties/google';

type Props = {
  location: string;
  mode?: 'place' | 'view';
  width?: number;
  height?: number;
  fullSize?: boolean;
};
export const GoogleMapViewer = ({
  location,
  width,
  height,
  mode = 'place',
  fullSize = false,
}: Props) => {
  if (location === '') return null;
  return (
    <GoogleMapsEmbed
      apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? ''}
      data-testId="google-maps-embed"
      height={fullSize ? '100%;' : height} // セミコロンを入れないと自動的にpxが付与される https://github.com/vercel/next.js/issues/64831
      mode={mode}
      q={location}
      width={fullSize ? '100%;' : width} // セミコロンを入れないと自動的にpxが付与される https://github.com/vercel/next.js/issues/64831
    />
  );
};
